import {inject, Injectable} from "@angular/core";
import {WrapperDto} from "../../dto/wrapper.dto";
import {OrgDto} from "../../dto/org.dto";
import {UrlBuilder} from "../../item/url.item";
import {HttpClient} from "@angular/common/http";
import {Observable, tap} from "rxjs";
import {SearchRequest} from "../../dto/search/search-table.dto.req";
import {map} from "rxjs/operators";
import {isUuid} from "../../../libs/utils/epic.utils";
import {VoidDto} from "../../dto/void.dto";
import {VehicleTireDto} from "../../dto/vehicle/vehicle-tire.dto";
import {SearchVehicleTireRes} from "../../dto/vehicle/search-vehicle-tire.res";

@Injectable({providedIn: 'root'})
export class VehicleTireRepo {

  private readonly vtRead = '/v1/org/{orgId}/vehicle/{vehicleId}/tire/{id}';
  private readonly vtWrite = '/v1/org/{orgId}/vehicle/{vehicleId}/tire';
  private readonly vtStateWrite = '/v1/org/{orgId}/vehicle/{vehicleId}/tire/{id}/state';
  private readonly vtDelete = '/v1/org/{orgId}/vehicle/{vehicleId}/tire/{id}/delete';
  private readonly vtSearch = '/v1/org/{orgId}/vehicle/{vehicleId}/tire/search';

  private readonly http: HttpClient = inject(HttpClient);

  public getById(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VehicleTireDto>> {
    const url = UrlBuilder.builder().addPath(this.vtRead).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.get<WrapperDto<VehicleTireDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, vehicleId: string, vt: VehicleTireDto): Observable<WrapperDto<VehicleTireDto>> {
    const url = UrlBuilder.builder().addPath(this.vtWrite).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<VehicleTireDto>>(url.getUrl(), vt, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public updateState(org: OrgDto, vehicleId: string, vt: VehicleTireDto): Observable<WrapperDto<VehicleTireDto>> {
    const url = UrlBuilder.builder().addPath(this.vtStateWrite).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', vt.id).build();
    return this.http.post<WrapperDto<VehicleTireDto>>(url.getUrl(), vt, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.vtDelete).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchVehicleTireRes>> {
    const vehicleId = request.filters.find((f) => f.pos === 1001)?.selected?.find((s) => isUuid(s));
    const url = UrlBuilder.builder().addPath(this.vtSearch).addParam('orgId', org.id).addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<SearchVehicleTireRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchVehicleTireRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
